export default __webpack_public_path__ + "static/media/enigma.aa9f0ee0.png";